import { render, staticRenderFns } from "./trainerInfo.vue?vue&type=template&id=b3d1cfee&scoped=true&"
import script from "./trainerInfo.vue?vue&type=script&lang=js&"
export * from "./trainerInfo.vue?vue&type=script&lang=js&"
import style0 from "./trainerInfo.vue?vue&type=style&index=0&id=b3d1cfee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d1cfee",
  null
  
)

export default component.exports